// Update 4 · Detached TAXI Calculator window (route /admin/taxi-calculator).
//
// Renders ONLY the calculator (in `detached` mode) with minimal administrative
// styling. It stays under the existing authenticated admin session (wrapped by
// AdminProtected in App.js) and never shows the public homepage, the public
// booking form, or the full administrative console.
import TaxiCalculator from "@/components/admin/TaxiCalculator";

export default function TaxiCalculatorPopupPage() {
  return (
    <div
      data-testid="taxi-calc-popup-page"
      className="min-h-screen bg-[#0c0d10] text-zinc-100 p-4"
      style={{ fontFamily: "Manrope, system-ui, sans-serif" }}
    >
      <div className="max-w-xl mx-auto">
        <TaxiCalculator detached />
      </div>
    </div>
  );
}
